module.exports = __webpack_public_path__ + "img/connect-5.a74c1355.svg";